import React, { useRef, useEffect, useCallback, useState} from 'react';
import {getRows} from './rows.js';
import {PADS} from './constants.js';
import Notes from 'midi/Notes.js';
import {connect} from 'react-redux';
import Pad from './Pad.js';

const MidiPadsOverview = ({sequencerEngine, keyboardEngine, octave, setOctave}) => { 
    const ref = useRef(undefined);
    
    useEffect(() => {
        if (!ref.current) {
            return;
        }
        // scroll to octave
        ref.current.scroll(0, (4 - octave) * 60);
    }, [octave]);

    let octaves = [4, 3, 2, 1, 0];
    return (
        <div ref={ref} className="midi-pads-overview">
          {octaves.map(
              x =>
                  <Octave
                    setOctave={setOctave}
                    isSelected={octave === x}
                    octave={x}
                    sequencerEngine={sequencerEngine}
                    keyboardEngine={keyboardEngine}/>)}
        </div>
    );
}

const Octave = ({octave, setOctave, sequencerEngine, keyboardEngine, isSelected}) => {
    let pads = getRows(octave);

    let className = "octave-pads";
    if (isSelected) {
        className += " selected";
    }
    return (
        <div
          onClick={() => setOctave(octave)}
          className={className}>
          {pads.map(
              row =>
                  <div className="pads-row">
                    {row.map(
                        pad => 
                            <Pad
                              notClickable={true}
                              mini={true}
                              value={pad}
                              keyboardEngine={keyboardEngine}
                              sequencerEngine={sequencerEngine}
                              trackNumber={undefined}
                            />)}
                  </div>)}
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MidiPadsOverview);
